import axios from '@_system/axios/axios.js'
export default {
	path: '/exchangeorder',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	exportdetail(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/exportdetail', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	
	queryGoodsAndSpec(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/queryGoodsAndSpec', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getreasondetail(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getreasondetail', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listTrade(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listTrade', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	enterExchangeorder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/enterExchangeorder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getExchange(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getExchange', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getOrder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getOrder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	getexchangebyid(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getexchangebyid', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	closeexchange(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/closeexchange', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/exchangeorder', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	}
	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
